module.exports = __webpack_public_path__ + "img/acura.2a4ea893.png";